import { render, staticRenderFns } from "./VenScLAddress_Search.vue?vue&type=template&id=98898d08"
import script from "./VenScLAddress_Search.vue?vue&type=script&lang=js"
export * from "./VenScLAddress_Search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports